(function() {
    "use strict";
    window.SunClipColorSelector = function() {
        this.currentCategory = "solid";
        this.selectedColors = {
            lens: null,
            bridge: null,
            magnet: null,
            crystal: null
        };
        return this;
    };
    window.SunClipColorSelector.prototype = {
        initialize: function(containerId, colorData) {
            this.lensContainer = document.getElementById(containerId);
            this.colorData = colorData;
            this.displayCategory("solid");
        },
        initializeBridges: function(containerId, bridgeData) {
            const container = document.getElementById(containerId);
            this.renderBridgeOptions(container, bridgeData);
        },
        initializeMagnets: function(containerId, magnetData) {
            const container = document.getElementById(containerId);
            this.renderMagnetOptions(container, magnetData);
        },
        initializeCrystals: function(containerId, crystalData) {
            const container = document.getElementById(containerId);
            this.renderCrystalOptions(container, crystalData);
        },
        displayCategory: function(category) {
            this.currentCategory = category;
            if (!this.lensContainer || !this.colorData) return;
            const colors = this.colorData[category];
            if (!colors) return;
            this.lensContainer.innerHTML = "";
            colors.forEach(color => {
                const colorElement = this.createColorSwatch(color, "lens");
                this.lensContainer.appendChild(colorElement);
            });
        },
        createColorSwatch: function(colorData, type) {
            const container = document.createElement("div");
            container.className = "color-swatch-container";
            const swatch = document.createElement("div");
            swatch.className = "color-swatch";
            swatch.dataset.colorId = colorData.id;
            swatch.dataset.type = type;
            if (colorData.gradient) {
                swatch.style.background = `linear-gradient(135deg, ${colorData.gradient.join(", ")})`;
            } else if (colorData.hex) {
                swatch.style.backgroundColor = colorData.hex;
            } else {
                swatch.classList.add("color-puck-placeholder");
            }
            if (colorData.mirror) {
                swatch.classList.add("mirror-swatch");
                swatch.style.background = `\n                    linear-gradient(135deg,\n                        ${colorData.hex} 0%,\n                        ${this.lightenColor(colorData.hex, 30)} 50%,\n                        ${colorData.hex} 100%\n                    )\n                `;
                swatch.style.boxShadow = `\n                    inset 0 1px 0 rgba(255,255,255,0.8),\n                    inset 0 -1px 0 rgba(0,0,0,0.3)\n                `;
            }
            swatch.addEventListener("click", () => {
                this.selectColor(colorData, type);
            });
            swatch.addEventListener("mouseenter", () => {
                this.showColorInfo(colorData);
            });
            swatch.addEventListener("mouseleave", () => {
                this.hideColorInfo();
            });
            const label = document.createElement("span");
            label.className = "color-puck-label";
            label.textContent = this.formatColorName(colorData.id);
            container.appendChild(swatch);
            container.appendChild(label);
            return container;
        },
        renderBridgeOptions: function(container, bridgeData) {
            container.innerHTML = "";
            bridgeData.forEach(bridge => {
                const option = document.createElement("div");
                option.className = "option-card";
                option.dataset.colorId = bridge.id;
                option.dataset.type = "bridge";
                option.innerHTML = `\n                    <div class="bridge-preview" style="background-color: ${bridge.hex}">\n                        <svg width="100" height="20" viewBox="0 0 100 20">\n                            <path d="M10,10 Q50,5 90,10"\n                                  stroke="${bridge.hex}"\n                                  stroke-width="3"\n                                  fill="none"/>\n                        </svg>\n                    </div>\n                    <div class="option-name">${bridge.name}</div>\n                `;
                option.addEventListener("click", () => {
                    this.selectColor(bridge, "bridge");
                });
                container.appendChild(option);
            });
        },
        renderMagnetOptions: function(container, magnetData) {
            container.innerHTML = "";
            magnetData.forEach(magnet => {
                const option = document.createElement("div");
                option.className = "option-card";
                option.dataset.colorId = magnet.id;
                option.dataset.type = "magnet";
                option.innerHTML = `\n                    <div class="magnet-preview">\n                        <div class="magnet-circle" style="background: radial-gradient(circle, ${magnet.hex} 0%, ${this.darkenColor(magnet.hex, 20)} 100%)">\n                            <div class="magnet-center"></div>\n                        </div>\n                    </div>\n                    <div class="option-name">${magnet.name}</div>\n                `;
                option.addEventListener("click", () => {
                    this.selectColor(magnet, "magnet");
                });
                container.appendChild(option);
            });
        },
        renderCrystalOptions: function(container, crystalData) {
            container.innerHTML = "";
            crystalData.forEach(crystal => {
                const option = document.createElement("div");
                option.className = "option-card";
                option.dataset.colorId = crystal.id;
                option.dataset.type = "crystal";
                if (crystal.id === "none") {
                    option.innerHTML = `\n                        <div class="crystal-preview no-crystal">\n                            <div class="no-crystal-text">No Crystal</div>\n                        </div>\n                        <div class="option-name">None</div>\n                    `;
                } else {
                    option.innerHTML = `\n                        <div class="crystal-preview">\n                            <div class="crystal-gem" style="background: ${this.getCrystalGradient(crystal.hex)}">\n                                <div class="crystal-facets"></div>\n                            </div>\n                        </div>\n                        <div class="option-name">${crystal.name}</div>\n                        ${crystal.price > 0 ? `<div class="option-price">+$${crystal.price}</div>` : ""}\n                    `;
                }
                option.addEventListener("click", () => {
                    this.selectColor(crystal, "crystal");
                });
                container.appendChild(option);
            });
        },
        selectColor: function(colorData, type) {
            if (window.navigator && window.navigator.vibrate) {
                window.navigator.vibrate(10);
            }
            document.querySelectorAll(`.option-card[data-type="${type}"], .color-swatch[data-type="${type}"]`).forEach(el => el.classList.remove("selected"));
            const selectedElement = document.querySelector(`[data-color-id="${colorData.id}"][data-type="${type}"]`);
            if (selectedElement) {
                selectedElement.classList.add("selected");
            }
            this.selectedColors[type] = colorData.id;
            if (type === "lens") {
                this.showColorInfo(colorData, true);
            }
            const event = new CustomEvent("colorSelected", {
                detail: {
                    type: type,
                    value: colorData.id,
                    category: this.currentCategory,
                    colorData: colorData
                }
            });
            window.dispatchEvent(event);
        },
        showColorInfo: function(colorData, persist) {
            const nameEl = document.getElementById("colorName");
            const descEl = document.getElementById("colorDescription");
            if (nameEl && descEl) {
                nameEl.textContent = colorData.name;
                descEl.textContent = colorData.description;
                if (!persist) {
                    setTimeout(() => {
                        if (nameEl.textContent === colorData.name) {
                            this.hideColorInfo();
                        }
                    }, 3e3);
                }
            }
        },
        hideColorInfo: function() {
            const nameEl = document.getElementById("colorName");
            const descEl = document.getElementById("colorDescription");
            if (nameEl && descEl) {
                const hasSelection = Object.values(this.selectedColors).some(v => v !== null);
                if (!hasSelection) {
                    nameEl.textContent = "Select a color";
                    descEl.textContent = "Choose from our premium lens colors";
                }
            }
        },
        lightenColor: function(hex, percent) {
            const num = parseInt(hex.replace("#", ""), 16);
            const amt = Math.round(2.55 * percent);
            const R = (num >> 16) + amt;
            const G = (num >> 8 & 255) + amt;
            const B = (num & 255) + amt;
            return "#" + (16777216 + (R < 255 ? R < 1 ? 0 : R : 255) * 65536 + (G < 255 ? G < 1 ? 0 : G : 255) * 256 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
        },
        darkenColor: function(hex, percent) {
            const num = parseInt(hex.replace("#", ""), 16);
            const amt = Math.round(2.55 * percent);
            const R = (num >> 16) - amt;
            const G = (num >> 8 & 255) - amt;
            const B = (num & 255) - amt;
            return "#" + (16777216 + (R > 0 ? R : 0) * 65536 + (G > 0 ? G : 0) * 256 + (B > 0 ? B : 0)).toString(16).slice(1);
        },
        getCrystalGradient: function(baseColor) {
            const lightColor = this.lightenColor(baseColor, 40);
            const darkColor = this.darkenColor(baseColor, 20);
            return `\n                linear-gradient(45deg,\n                    ${lightColor} 0%,\n                    ${baseColor} 30%,\n                    ${darkColor} 70%,\n                    ${baseColor} 100%\n                )\n            `;
        },
        formatColorName: function(colorName) {
            if (!colorName || colorName === "none") return colorName;
            return colorName.replace(/([A-Z])/g, " $1").trim();
        },
        getSelectedColors: function() {
            const result = {};
            for (const key in this.selectedColors) {
                result[key] = this.selectedColors[key];
            }
            return result;
        },
        setSelectedColor: function(type, colorId) {
            let colorData = null;
            switch (type) {
              case "lens":
                for (const category of Object.values(this.colorData)) {
                    colorData = category.find(c => c.id === colorId);
                    if (colorData) break;
                }
                break;
            }
            if (colorData) {
                this.selectColor(colorData, type);
            }
        },
        clearSelection: function(type) {
            this.selectedColors[type] = null;
            document.querySelectorAll(`[data-type="${type}"]`).forEach(el => el.classList.remove("selected"));
            if (type === "lens") {
                this.hideColorInfo();
            }
        },
        clearAllSelections: function() {
            const self = this;
            Object.keys(this.selectedColors).forEach(function(type) {
                self.clearSelection(type);
            });
        }
    };
    window.ColorSelector = window.SunClipColorSelector;
    window.ConfiguratorUI = window.SunClipColorSelector;
})();